<template>
  <div class="form-dialog">
    <div class="form-body-scroll">
      <div
        class="form-title padding-title"
        v-text="'Formulario de Contacto'"
      />
      <div class="form-box-body">
        <vuescroll>
          <div class="form-components scroll">
            <div
              class="form_combo_text"
              v-text="text"
            />

            <div
              class="form_label"
              v-text="'Ingresa tu Nombre y Apellido *'"
            />
            <div class="form__field">
              <label for="nombre"><v-icon
                name="user"
                scale="1"
              /></label>
              <input
                id="nombre"
                ref="nombre"
                v-model="nombre"
                autocomplete="off"
                type="text"
                name="nombre"
                value=""
                placeholder="Nombre"
                required
@focus="_clearError" @keyup.enter="focusTo('pass')" @keypress="keyPressCheckSpecialChars($event,'name')" @change="cleanSpecialChars('nombre','name')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Ingresa tu email *'"
            />
            <div class="form__field">
              <label for="email"><v-icon
                name="envelope"
                scale="1"
              /></label>
              <input
                id="email"
                ref="email"
                v-model="email"
                class="email"
                autocomplete="off"
                type="text"
                name="email"
                value=""
                placeholder="Email"
                required
@focus="_clearError" @keyup.enter="focusTo('pass')" @keypress="keyPressCheckSpecialChars($event,'email')" @change="cleanSpecialChars('email','email')"
              >
            </div>

            <div
              class="form_label"
              v-text="'Teléfono de contacto *'"
            />
            <div class="form__field">
              <label for="telefono"><v-icon
                name="mobile-alt"
                scale="1"
              /></label>
              <input
                id="telefono"
                ref="telefono"
                v-model="telefono"
                autocomplete="off"
                type="text"
                name="telefono"
                value=""
                placeholder="Teléfono"
                required
@focus="_clearError" @keyup.enter="focusTo('pass')" @keypress="keyPressCheckSpecialChars($event,'phone')" @change="cleanSpecialChars('telefono','phone')"
              >
            </div>
            <!-- TEXTAREA -->

            <div class="score-subtitle">
              Detalle Solicitud
            </div>
            <div class="score-comments">
              <textarea v-model="comentario" />
            </div>
          </div>
        </vuescroll>
      </div>

      <!-- BOTONES -->
      <div class="form-box-button scroll margin_btn">
        <button
          class="button-secondary"
          @click="_cancelClick"
        >
          Cancelar
        </button>
        <button
          class="button-primary"
          @click="_sentClick"
        >
          Enviar
        </button>
      </div>
      <!-- MSG -->
      <div class="form-error">
        &nbsp;{{ errormsg }}
      </div>
    </div>
  </div>
</template>
<script>

import { serverUI } from './main'
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/user'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/comment'
import 'vue-awesome/icons/calendar'
import 'vue-awesome/icons/envelope'
import 'vue-awesome/icons/credit-card'
import 'vue-awesome/icons/dollar-sign'
import 'vue-awesome/icons/mobile-alt'
import 'vue-awesome/icons/exchange-alt'
import utils from './utils'

export default {
  components: {
    'v-icon': Icon
  },
  props: {
  },
  data () {
    return {
      title: '',
      text: '',
      errormsg: '',
      comentario: '',
      nombreOrigen: '',
      emailOrigen: '',
      telefonoOrigen: '',
      nombre: '',
      email: '',
      telefono: ''
    }
  },
  computed: {
  },
  created () {
    // Señales recibidas
    serverUI.$on('FormEvent', (e) => {
      if (e.form !== 'ContactForm') return
      if (e.evento === 'init') {
        // console.log("asigna por init:");
        // console.log("e.dato:",e.dato);
      }
      if (e.evento === 'newdata') {
        // console.log("asigna por newdata:");
        // console.log("e.dato:",e.dato);
        this.title = e.dato.title ? e.dato.title : 'Contactar Ejecutivo'
        this.text = e.dato.text ? e.dato.text : ''
        this.nombreOrigen = e.dato.nombre ? e.dato.nombre : ''
        this.emailOrigen = e.dato.email ? e.dato.email : ''
        this.telefonoOrigen = e.dato.telefono ? e.dato.telefono : ''
        this.nombre = this.nombreOrigen
        this.email = this.emailOrigen
        this.telefono = this.telefonoOrigen
      }
    })
  },
  methods: {
    _clearError () {
      this.errormsg = ''
    },
    focusTo (el) {
      if (el === 'pass') this.$refs.password.focus()
    },
    keyPressCheckSpecialChars (evt, type) {
      return utils.keyPressCheckSpecialChars(evt, type)
    },
    cleanSpecialChars (val, type) {
      if (!val) return
      this[val] = utils.cleanSpecialChars(this[val], type)
      return this[val]
    },
    _sentClick () {
      this.errormsg = ''
      if (!this.nombre) {
        this.errormsg = 'Debes ingresar nombre'
        return
      }
      if (!this.email) {
        this.errormsg = 'Debes ingresar email'
        return
      }
      if (!utils.isEmail(this.email)) {
        this.errormsg = 'Formato email incorrecto'
        return
      }
      if (!this.telefono) {
        this.errormsg = 'Debes ingresar teléfono'
        return
      }
      /* if(!this.comentario){
        this.errormsg = 'Debes ingresar comentario';
        return;
      } */
      serverUI.$emit('FormEvent', {
        form: 'AlviContactoForm',
        evento: 'sentClick',
        data: {
          fields: {
            email: this.email,
            firstname: this.nombre,
            lastname: '',
            company: '',
            phone: this.telefono,
            address: '',
            city: '',
            message: this.comentario
          }
        }
      })
    },
    _cancelClick () {
      serverUI.$emit('FormEvent', {
        form: 'AlviContactoForm',
        evento: 'cancelClick',
        dato: 'Cancelado'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>

  .form__field{
    margin-bottom: 7px;
 }

  /*.form-box-body {
    height: 300px;
}*/
</style>
